import script from "./VietnamIslandMarker.vue?vue&type=script&lang=ts&setup=true"
export * from "./VietnamIslandMarker.vue?vue&type=script&lang=ts&setup=true"

import "./VietnamIslandMarker.vue?vue&type=style&index=0&id=3fc3f9be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc3f9be"]])

export default __exports__